import React, { useEffect, useState } from 'react';
import { getAllFolder } from '../api/folderapi';
import FileContainer from '../Component/FileContainer';

const Audio = () => {
  const [audio, setAudio] = useState([]);
  const [isLoading,setIsLoading] = useState(false)

  useEffect(() => {
    setIsLoading(true)
    getAllFolder()
      .then((res) => {
        const audioFiles = res.data.filter(
          (item) => item.mimeType && item.mimeType.toLowerCase().includes('audio')
        );
        setAudio(audioFiles);
      })
      .catch((err) => console.log(err));
      setIsLoading(false)
  }, []);

  return (
    <div className=" mt-[10%] md:mt-[4%]">
      
      <div className=' mt-5'></div>
      <h2 className="mb-4 text-xl font-semibold">Audio Files</h2>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
        {audio.map((track, index) => (
          <FileContainer key={index} className="flex flex-col items-center p-4 overflow-hidden border rounded-md shadow">
            <audio controls className="w-full">
              <source src={track.url} type={track.mimeType} />
              Your browser does not support the audio element.
            </audio>
            <div className="mt-2 text-sm font-medium text-center text-gray-700">
              {track.name}
            </div>
          </FileContainer>
        ))}
      </div>
    </div>
  );
};

export default Audio;
